var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.isPast + _vm.notAvailable + _vm.isSelected + 'calendar-day',on:{"click":function($event){return _vm.action($event)}}},[_c('span',{staticClass:"selection"}),_c('span',{staticClass:"sm-text"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }